import { render } from "./HeroiconsOutlineCloud.vue?vue&type=template&id=52f6b60e"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCloud.vue"]])

export default __exports__